// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load-button{position:relative}.error-message{position:absolute;bottom:-28px;right:50%;transform:translateX(50%);margin:0;width:300px;text-align:center}::ng-deep .ngx-file-drop__drop-zone{height:150px !important}::ng-deep .ngx-file-drop__content{height:150px !important}", ""]);
// Exports
module.exports = exports;
